module.exports = __webpack_public_path__ + "static/media/how_fr_fr.9f13ee28.vtt";